import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const DolaresFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='Cuenta USD' htmlFor='input-dolares' md={12} />
      <Col md={12}>
        <Field name='cuentaContable12USD'>
          {({ field }) => <Form.InputText {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='input-dolares' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DolaresFormGroup)
